export const PAYMENT_METHODS = {
	PIX: 'pix',
	BANKSLIP: 'bankSlip',
	MUVICARD: 'muvicard',
	CREDIT_CARD: 'creditCard',
	ONLINE_DEBT: 'onlineDebt',
}
